module.exports = __webpack_public_path__ + "img/chevron-left.defc2eca.svg";